export default __webpack_public_path__ + "static/media/cross.46e77b74.svg";